// extracted by mini-css-extract-plugin
export default {"descriptions":"jztwJvHnO51JYFWqDDYe","modal":"uv8sLOQLh8TjamFwVH7K"};